module.exports = __webpack_public_path__ + "img/01_slides.05aabe50.png";